export default {"src":"/_next/static/image/public/images/ic_pay_mada.de99af983b611541a23344359c8df84c.svg","height":12,"width":38};